import { useTranslation } from 'react-i18next';
import { Table } from '../../../../../components';
import HrSearchComponents from '../../../../HRAdmin/components/HrSearchComponent';
import { Typography } from '@material-ui/core';
import { Box, Modal } from '@mui/material';
import { colors } from '../../../../../helpers/colors';
import { useListEmployees } from '../../../../EmployeeData/api';

import EmployeeFaceEnroll from './EmployeeFaceEnroll';
import EmployeeFacePhotoView from './EmployeeFacePhotoView';
import { useState } from 'react';
import { useDebounce } from '../../../../../hooks';

const Faceenroll = () => {
  const [debouncedTerm, setQuery] = useDebounce();
  const [openModel, closeModel] = useState(false);

  const [enrollOpen, setEnrollOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [viewPhotoOpen, setViewPhotoOpen] = useState(false);

  const { t } = useTranslation();
  const customRender = {
    sort: true,
    filter: true,
    customBodyRender: (value) => <td className="text-gray-700">{value}</td>,
  };

  const handleViewPhoto = (item) => {
    setSelectedEmployee({
      id: item?.id,
      name: item?.first_name
        ? `${item?.first_name} ${item?.middle_name ?? ''} ${item?.last_name ?? ''}`
        : '--:--',
    });
    setViewPhotoOpen(true);
  };

  const { data, count, isLoading, refetch } = useListEmployees({
    statusFilter: 1,
    textFilter: debouncedTerm,
    menu: 'faceenroll',
  });
  const customBodyRender = {
    sort: true,
    filter: true,
    customBodyRender: (value) => <td className="textstyle">{value}</td>,
  };

  const attendanceColoumns = [
    {
      name: 'id',
      label: t('Staff Id'),
      options: customRender,
    },
    {
      name: 'staffName',
      label: t('Staff Name'),
      options: customBodyRender,
    },
    {
      name: 'department',
      label: t('Department'),
      options: customRender,
    },
    {
      name: 'faceenroll',
      label: t('Is Face Enrolled'),
      options: customRender,
    },
    {
      name: 'action',
      label: t('Action'),
    },
  ];

  const handleEnrollFace = (item) => {
    setSelectedEmployee({
      id: item?.id,
      name: item?.first_name
        ? `${item?.first_name} ${item?.middle_name ?? ''} ${item?.last_name ?? ''}`
        : '--:--',
    });
    setEnrollOpen(true);
  };

  const attendanceDetails = data?.map((item) => {
    return {
      id: item?.staff_id ?? '--:--',
      staffName: item?.first_name
        ? item?.first_name + ' ' + item?.middle_name + ' ' + item?.last_name
        : '--:--',
      department: item?.emp_job_detail?.department.name ?? '--:--',
      faceenroll: (
        <span
          style={{
            color: item?.rekognition_face_id ? colors.green : colors.red,
            fontWeight: 600,
          }}
        >
          {item?.rekognition_face_id ? t('Yes') : t('No')}
        </span>
      ),
      action: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <i
            className="las la-camera"
            title={t('Enroll Face')}
            style={{
              fontSize: '1.3em',
              color: item?.rekognition_face_id ? colors.green : colors.grey,
              cursor: 'pointer',
            }}
            onClick={() => handleEnrollFace(item)}
          ></i>
          {item?.rekognition_face_id && (
            <i
              className="las la-eye"
              title={t('View Enrolled Photo')}
              style={{
                fontSize: '1.3em',
                color: colors.grey,
                cursor: 'pointer',
              }}
              onClick={() => handleViewPhoto(item)}
            ></i>
          )}
        </div>
      ),
    };
  });

  return (
    <>
      <div className="flex gap-4 mb-4 mt-1">
        <HrSearchComponents
          value={debouncedTerm}
          onChange={(e) => {
            setQuery(e);
          }}
        />
      </div>
      <Table
        columns={attendanceColoumns}
        data={attendanceDetails}
        isLoadingData={isLoading}
        count={count}
      />

      <Modal open={openModel} onClose={() => closeModel()}>
        <Box
          className="customeModal-Attendance app-modal"
          sx={{ width: '600px' }}
        >
          <Box style={{ display: 'flex', marginBottom: '2em' }}>
            <Box style={{ flex: 1 }}>
              <Typography className="welcome-text">
                {t('Update\n')}
                <Typography display="inline" className="welcome-text2">
                  {t('External Id')}
                </Typography>
              </Typography>
            </Box>
            <i
              className="las la-times"
              style={{
                fontSize: '1.5em',
                color: colors.grey,
                cursor: 'pointer',
              }}
              onClick={() => closeModel(false)}
            ></i>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={enrollOpen}
        onClose={() => {
          setEnrollOpen(false);
          setSelectedEmployee(null);
        }}
      >
        <Box
          sx={{
            width: '420px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: '8px',
            p: 3,
          }}
        >
          <Box style={{ display: 'flex', marginBottom: '1em' }}>
            <Box style={{ flex: 1 }}>
              <Typography className="welcome-text">
                {t('Enroll Face')}
              </Typography>
            </Box>
            <i
              className="las la-times"
              style={{
                fontSize: '1.5em',
                color: colors.grey,
                cursor: 'pointer',
              }}
              onClick={() => {
                setEnrollOpen(false);
                setSelectedEmployee(null);
              }}
            ></i>
          </Box>

          {selectedEmployee && (
            <EmployeeFaceEnroll
              employeeId={selectedEmployee.id}
              employeeName={selectedEmployee.name}
              onEnrolled={() => {
                setEnrollOpen(false);
                setSelectedEmployee(null);
                refetch?.();
              }}
            />
          )}
        </Box>
      </Modal>

      {viewPhotoOpen && selectedEmployee && (
        <EmployeeFacePhotoView
          open={viewPhotoOpen}
          employeeId={selectedEmployee?.id}
          employeeName={selectedEmployee?.name}
          onClose={() => {
            setViewPhotoOpen(false);
            setSelectedEmployee(null);
          }}
        />
      )}
    </>
  );
};

export default Faceenroll;
